<template>
    <div>
        <Content :style="{padding: '24px', minHeight: '480px', background: '#fff'}">
            <Tabs value="name1">
                <TabPane label="日统计报表" name="name1">
                    <CDayReport />
                </TabPane>
                <TabPane label="月统计报表" name="name2">
                    <CDayMonthReport />
                </TabPane>
            </Tabs>
        </Content>
    </div>
</template>
<script>
import Constants from "@/utils/constants"
import CDayReport from "./CDayReport.vue"
import CDayMonthReport from "./CDayMonthReport.vue"

export default {
    name: 'WaybillDataReport',
    data() {
        return {

        }
    },
    components: {
        CDayReport,
        CDayMonthReport
    
    },
}
</script>